export const zh_CN: Record<string, any> = {
  pluginName: '组件库',
};
